import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TrpcService } from '../../services/trpc/trpc.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-lease-view',
  templateUrl: './lease-view.component.html',
  styleUrl: './lease-view.component.scss'
})
export class LeaseViewComponent {

  @Input() lease_id!: string;

  leaseDetails: any = undefined;
  loadingLeaseDetails: boolean = false;

  constructor(
    public route: ActivatedRoute,
    private trpcService: TrpcService,
    private messageService: MessageService,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if(environment.buildMode === 'serve') {
      this.route.params.subscribe((queryParams) => {
        this.loadingLeaseDetails = true;
        this.getLeaseData(queryParams['lease_id']);
      })
    }

    // if(environment.buildMode === 'web-component') {
    //   this.loadingLeaseDetails = true;
    //   this.getLeaseData(this.lease_id);
    // }
  }

  private async getLeaseData(lease_id: string) {
    this.loadingLeaseDetails = true;
    let leaseResult: any = await this.trpcService.trpc.lease.getLeaseDetails.query({ lease_id: lease_id }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

    if (leaseResult?.length) {
      this.leaseDetails = leaseResult[0];

      //Clear selected files
      let blob: any = null;
      const buf = new Uint8Array(this.leaseDetails.file.data);
      blob = new Blob([buf], { type: "application/pdf" });
      blob.lastModifiedDate = new Date();
      blob.name = this.leaseDetails['file_name'];
      this.leaseDetails['blobURL'] = window.URL.createObjectURL(blob);
      this.leaseDetails['blobURLSafe'] = this._sanitizer.bypassSecurityTrustResourceUrl(this.leaseDetails['blobURL']);

      this.leaseDetails['file_size'] = this.getFileSize(this.leaseDetails['file_size']);

    }
    this.loadingLeaseDetails = false;
  }

  getFileSize(size: any): string {
    let units = ['B', 'KB', 'MB']
    let bytes = size;
    let i = 0

    for (i; bytes > 1024; i++) {
      bytes /= 1024;
    }

    bytes = parseFloat(bytes.toFixed(2)) + ' ' + units[i]
    return bytes;
  }

  downloadFile() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = this.leaseDetails['blobURL'];
    link.download = this.leaseDetails['file_name'];
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

}
